import { useRef } from 'react';
import useFiltersDropdownHelper from 'hooks/FiltersDropdownHelper';
import styles from '../../styles/MobileBaseFiltersDropdown.module.scss';
import MobileBaseFiltersDropdownOption from 'components/Functional/Filters/MobileFilter/MobileBaseFiltersDropdownOption';
import ExpandableContent from 'components/Generic/ExpandableContent';

type Props = {
  toggleDropdown: (filter) => void;
  optionSelect: (option, filterId) => void;
  filter: any;
  children?: any;
  isFetching: boolean;
  isOpen: boolean;
};

const MobileBaseFiltersDropdown = ({
  toggleDropdown,
  filter,
  isFetching,
  isOpen,
  children,
  optionSelect,
}: Props) => {
  const dropdownContent = useRef();
  const { filterOptions } = useFiltersDropdownHelper({ filter: filter });
  return (
    <div
      className={`flex-column d-flex align-items-start ${styles['dropdown-section-root']}`}
      onKeyDown={(e) => {
        if (e.code === 'Esc') {
          toggleDropdown(undefined);
        }
      }}
    >
      <button
        className={`d-flex align-items-center justify-content-between expandable w-100 ${styles['dropdown-button']} btn btn-naked`}
        aria-expanded={isOpen ? 'true' : 'false'}
        onClick={() => toggleDropdown(filter.id)}
      >
        <span className="h5">{filter.displayName}</span>
        <span className="ms-auto">
          <em className={`d-flex bi-chevron-${isOpen ? 'up' : 'down'}`} aria-hidden="true" />
        </span>
      </button>
      <div ref={dropdownContent} className="dropdown__content background-white w-100">
        <ExpandableContent show={isOpen}>{children}</ExpandableContent>
        <div className="filter-dropdown-options-wrapper d-flex flex-column w-100">
          <ExpandableContent show={isOpen}>
            {filterOptions.map((filterOption) => (
              <MobileBaseFiltersDropdownOption
                key={filterOption.id}
                filterOption={filterOption}
                isVisible={isOpen}
                isFetching={isFetching}
                optionSelect={(option) => optionSelect(option, filter.id)}
              />
            ))}
          </ExpandableContent>
        </div>
      </div>
    </div>
  );
};

export default MobileBaseFiltersDropdown;
